module.exports = __webpack_public_path__ + "static/media/ad.d4227482.svg";